// import MultiRangeSlider from '@/common/RangeDouble/MultiRangeSlider';
// import { RootContext } from '@/context/RootContext';
// import React, { useContext, useEffect, useRef, useState } from 'react'

// export default function PriceRange({data,  minPrice,
//     setMinPrice,
//     maxPrice,
//     setMaxPrice,
//     mn,
//     mx,routeManageMent=false,
//     containerRange="",
//     wrapperContainer=""
//   }) {
//     const priceRangeRef = useRef();
//     // const [min, setMin] = useState(mn);
//     // const [max, setMax] = useState(mx);
//     const [initialMin, setInitialMin] = useState(mn);
//     const [initialMax, setInitialMax] = useState(mx);
//     // const [active, setActive] = useState(["price"]);
//     const [editRange, setEditRange] = useState(true);
//     const {filters,setFilters, extraInfo, updateUrlByFilters}= useContext(RootContext)

//   console.log("mx==", mx)
//     // useEffect(() => {
//     //   setInitialMin(minPrice);
//     //   setInitialMax(maxPrice);
//     // }, [active]);
//     useEffect(()=>{

//       // setMx(maxIs);
//       if (data?.minPrice || data?.maxPrice){
//         let minIs= data?.minPrice;
//         let maxIs= data?.maxPrice;

//       console.log("minIs==", minIs, maxIs,data)
//       setMaxPrice(maxIs);
//       setMinPrice(minIs)
//       minIs && setInitialMin(minIs);
//       maxIs && setInitialMax(maxIs);
//       }
//       else{

//         setInitialMin(mn);
//         setInitialMax(mx)
//       }
//       // setInitialMin(mn);
//       // setInitialMax(mx);
//       // setApiPrice({ min: minIs, max: maxIs });
//     },[data, mx, mn])

//     console.log("mx====", mx, maxPrice, initialMax)
//     console.log("min====", mn, minPrice, initialMin)
//     console.log("condition==", minPrice ,maxPrice , initialMax , initialMin, mx, mn);
//   return (
// <>
// {maxPrice && initialMax && extraInfo?.max && (
//                     <MultiRangeSlider
//                   min={mn}
//                   max={mx}
//                   step={1}
//                   initialMax={initialMax}
//                   initialMin={initialMin}
//                   belowRange={minPrice}
//                   upperRange={maxPrice}
//                   rangeRef={priceRangeRef}
//                   editRange={editRange}
//                   setEditRange={setEditRange}
//                   onChange={({ min, max }:{min?:string, max?:string}) => {
//                     // alert("1");
//                     console.log(`min= ${min}, max = ${max}`);
//                     setMinPrice(min);
//                     setMaxPrice(max);

//                   }}
//                   containerRange={containerRange}
//                   wrapperContainer={wrapperContainer}
//                   title={``}
//                   onChangeNewState={(x?:string | number) => {
//                     console.log("x=========", x)
//                     // setTimeout(() => {
//                       if (!routeManageMent){
//                       setFilters({...filters, minPrice:x?.min, maxPrice: x?.max})
//                       }else{
//                       updateUrlByFilters("priceRange", {min: x?.min, max: x?.max})
//                       }

//                     //   setMinPrice(x?.min);
//                     // setMaxPrice(x?.max);
//                     // }, 1000);
//                     // setApiPrice(x);

//                     // handlePageChange(1)
//                     // setParams({ ...params, start: 0, limit: itemsPerPage });
//                   }}
//                 />
//               )}
// </>
//   )
// }

// ====================

'use client';

import MultiRangeSlider from '@/components/general/RangeDouble/MultiRangeSlider';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';

interface PriceData {
  minPrice?: number;
  maxPrice?: number;
}

interface RangeState {
  min: number;
  max: number;
}

interface PriceRangeProps {
  data?: PriceData;
  minPrice: number;
  setMinPrice: Dispatch<SetStateAction<number>>;
  maxPrice: number;
  setMaxPrice: Dispatch<SetStateAction<number>>;
  mn: number;
  mx: number;
  routeManageMent?: boolean;
  containerRange?: string;
  wrapperContainer?: string;
}

export default function PriceRange({
  data,
  minPrice,
  setMinPrice,
  maxPrice,
  setMaxPrice,
  mn,
  mx,
  routeManageMent = false,
  containerRange = '',
  wrapperContainer = '',
}: PriceRangeProps) {
  const priceRangeRef = useRef<HTMLDivElement | null>(null);

  const [initialMin, setInitialMin] = useState<number>(mn);
  const [initialMax, setInitialMax] = useState<number>(mx);
  const [editRange, setEditRange] = useState<boolean>(true);

  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const minPriceFromUrl = searchParams.get('minPrice');
  const maxPriceFromUrl = searchParams.get('maxPrice');

  useEffect(() => {
    // First priority: URL parameters
    if (minPriceFromUrl !== null && maxPriceFromUrl !== null) {
      const min = Number(minPriceFromUrl);
      const max = Number(maxPriceFromUrl);

      setMinPrice(min);
      setMaxPrice(max);
      setInitialMin(min);
      setInitialMax(max);
      return;
    }

    // Second priority: API data
    if (data?.minPrice != null && data?.maxPrice != null) {
      const min = Number(data.minPrice);
      const max = Number(data.maxPrice);

      setMinPrice(min);
      setMaxPrice(max);
      setInitialMin(min);
      setInitialMax(max);
      return;
    }

    // Default values
    setMinPrice(mn);
    setMaxPrice(mx);
    setInitialMin(mn);
    setInitialMax(mx);
  }, [data, mn, mx, minPriceFromUrl, maxPriceFromUrl, setMinPrice, setMaxPrice]);

  // const updatePriceInUrl = (min: number, max: number) => {
  //   const params = new URLSearchParams(searchParams.toString());

  //   params.set('minPrice', String(min));
  //   params.set('maxPrice', String(max));

  //   router.replace(`${pathname}?${params.toString()}`, {
  //     scroll: false,
  //   });
  // };
  const updatePriceInUrl = (min: number, max: number) => {
    const params = new URLSearchParams(searchParams.toString());

    params.set('page', '1');

    if (min === mn && max === mx) {
      params.delete('minPrice');
      params.delete('maxPrice');
    } else {
      params.set('minPrice', String(min));
      params.set('maxPrice', String(max));
    }

    router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  };
  const normalizedMin = Math.floor(mn);
  const normalizedMax = Math.ceil(mx);
  return (
    <>
      {maxPrice != null && initialMax != null && (
        <MultiRangeSlider
          min={normalizedMin}
          max={normalizedMax}
          step={1}
          initialMin={initialMin}
          initialMax={initialMax}
          belowRange={minPrice}
          upperRange={maxPrice}
          rangeRef={priceRangeRef}
          editRange={editRange}
          setEditRange={setEditRange}
          containerRange={containerRange}
          wrapperContainer={wrapperContainer}
          title=""
          // onChange={({ min, max }: { min?: string; max?: string }) => {
          //   if (min !== undefined) {
          //     setMinPrice(Number(min));
          //   }

          //   if (max !== undefined) {
          //     setMaxPrice(Number(max));
          //   }
          // }}
          // onChangeNewState={(x?: RangeState) => {
          //   if (!x) return;

          //   setMinPrice(Number(x.min));
          //   setMaxPrice(Number(x.max));

          //   updatePriceInUrl(x.min, x.max);
          // }}
          onChange={({ min, max }: { min?: string; max?: string }) => {
            if (min !== undefined) {
              setMinPrice(Math.round(Number(min)));
            }

            if (max !== undefined) {
              setMaxPrice(Math.round(Number(max)));
            }
          }}
          onChangeNewState={(x?: RangeState) => {
            if (!x) return;

            const min = Math.round(x.min);
            const max = Math.round(x.max);

            setMinPrice(min);
            setMaxPrice(max);

            updatePriceInUrl(min, max);
          }}
        />
      )}
    </>
  );
}
